
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = $('body').data('money-format');
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function changeComparePrice(time){
  $('.product__info-container .price__loader').show();
  $('.product__info-container .price__regular').hide();
  setTimeout(function() {

    var count=0;
    var x=setInterval(function(){

    var price = $('.product__info-container .price__regular .price-item--regular').data('price');
   
    $('.gpo-element .gpo-swatches input[type="radio"]:checked').each(function(i, obj) {
      var price_addon = $(this).closest('.gpo-element').find('.gpo-label span.addOn').text();
      price_addon = price_addon.replace(" ", "").replace("(", "").replace(")", "").replace("+$","").replace("+£","").replace("+€","").replace(",",".");
      //console.log(price_addon);
      price_addon = price_addon * 100;
      //console.log(price_addon);
      price = parseInt(price) + price_addon;
    });

    $('.spice-spa-addon-product-item').each(function(i, obj) {
      var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
      if (checkbox.length > 0){
         var variant_price =  $(this).find('.spice-spa-addon-price-main').attr('variant_price');
         var variant_quantity =  $(this).find('[name="sg-pro-access-qty"]').val();
        variant_price = parseInt(variant_price) * variant_quantity;
        //console.log(variant_price);
        price = parseInt(price) + variant_price;
      }
    });

    var percent_price = $('.product__info-container .price__regular .price-item--regular').data('percent');
    var calculator_price = (100 - percent_price) * 0.01;
    var compare_price = price / calculator_price; 
    //var sale_price = price * calculator_price; 

      $('.product__info-container .price__regular .price-item--regular').text(Shopify.formatMoney(price, $('body').data('money-format')));
      $('.product__info-container .price__regular .price-item--sale').text(Shopify.formatMoney(compare_price, $('body').data('money-format')));
      
      if(count > 5){
        console.log('stop Interval');
        clearInterval(x);
        $('.product__info-container .price__loader').hide();
        $('.product__info-container .price__regular').show();
      }
      count++;
    }, time);
    
  }, 1000);
}

function changeBackground(){
  setTimeout(function() {
    var pictureType = $('input[name="Select Picture Style"]:checked').val();
    var premadeBackground = $('input[name="Select Background"]:checked').val();
    
    var combined = pictureType +' - '+ premadeBackground;
    combined = combined.toLowerCase().replace("'", "").replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    if(combined != ''){ 
      var sectionID = $('#product-section-id').val();                           
      var imageID = $('.img-'+combined).data('image-id');
      const mediaGallery = document.getElementById('MediaGallery-'+sectionID);
      mediaGallery.setActiveMedia(sectionID+'-'+imageID, true);
      const modalContent = document.querySelector('#ProductModal-'+sectionID+' .product-media-modal__content');
      const newMediaModal = modalContent.querySelector('[data-media-id="'+imageID+'"]');
      modalContent.prepend(newMediaModal);
    }
    
  }, 300);
}

function changeAddonAdditionalInfo(){

  $('.spice-spa-addon-product-item').each(function(i, obj) {
    var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
    if (checkbox.length > 0){
   
      var AdditionalField =  $(this).find('.spice-spa-addon-product-text-field');
      if (AdditionalField.length > 0){
      
        var pid= $(this).find('.spice_properties');               
        var headingName = $('.product__info-container .product__title').text();
        var numberValue = $('input[name="Select Number of People and Pets"]:checked').val();
        var styleValue = $('input[name="Select Picture Style"]:checked').val();
        var backgroundValue = $('input[name="Select Background"]:checked').val();

        var stringInfo = $.trim(headingName);
             
        if(numberValue != ''){
          stringInfo += ' - ' + numberValue;
        }
        if(styleValue != ''){
          stringInfo += ' - ' + styleValue;
        }
        if(backgroundValue != ''){
          stringInfo += ' - ' + backgroundValue;
        }
        pid.text(stringInfo);
      }
    }
  });
  
}

function checkRequiredFields(){
  var check_error = false;
  $('.gpo-form__group.show-addon-for-option').each(function(i, obj) {
    if($(this).hasClass("has-error")){
      check_error = true;
    }
  });  
  if(!check_error){
    $('button.product-form__submit').attr('disabled',false);
  }else{
    $('button.product-form__submit').attr('disabled',true);
    $('input.spice-spa-addon-checkbox-input').each(function(i, obj) {
      $(this).prop("checked",false);
    });
  }
}

$( window ).on( "load", function() {

  // Border text for AU Father’s Day
  $('.product__info-container p.product__text').each(function(i, obj) {
    console.log($(this).text());
    
    if($(this).text().indexOf('AU Father’s Day Special') != -1){
        $(this).addClass('border');
    }
  });

  // custom dropdown Number of People and Pets
  setTimeout(function() {
    $('#custom-dropdown').change(function(){
      console.log($(this).val());
      const number = $(this).val();
      $('input[name="Select Number of People and Pets"][value="'+number+'"]').prop('checked', true);
      changeComparePrice(200);
    });

    $('#custom-dropdown-gift').change(function(){
      console.log($(this).val());
      const giftVal = $(this).val();
      $('input[name="Denominations"][value="'+giftVal+'"]').prop('checked', true);
    });

    
  }, 500);  

  $('.gpo-element .gpo-swatches input[type="radio"]').click(function(){
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 500);
  });
  
  $('input[name="Select Background"]').click(function(){
    changeBackground();
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    checkRequiredFields();
  });
  
  $('input[name="Select Picture Style"]').click(function(){
    changeBackground();
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
  });
  
  $('input[name="Select Number of People and Pets"]').click(function(){
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
  });

  

   /* "No print - digital only order" checkbox gate removed: add-ons are now
      required for every order, so the only add-to-cart gate is the
      capture-phase guard below. (Old handlers here could block a valid
      add-on cart add unless the stale checkbox was ticked.) */
  

  setTimeout(function() {

    if($('.gpo-element .gpo-swatches input[type="radio"]').length > 0){
      changeComparePrice();
    }
    
    

    /* Repair swatch images: the imported Globo option sets carry empty
       asset names, so their <img> tags render with no src. The files live
       on this store's own CDN -- fill them in by option value. Does
       nothing for swatches that already have an image. */
    var gpoSwatchFiles = {
      "Nightwatch Alley":      "swatch-17595864444104.jpg",
      "Secret Program Vault":  "swatch-17595871772162.jpg",
      "Webbed Alley":          "swatch-17598424296137.jpg",
      "Hero Tower Rooftop":    "swatch-17600121240130.jpg",
      "Globe Tower Skyline":   "swatch-17595864507981.jpg",
      "Skybound":              "swatch-17595864632744.jpg",
      "Nightfall Backstreet":  "swatch-17598425010023.jpg",
      "Fourpoint Tower Plaza": "swatch-17599167608507.jpg",
      "Summit Overlook":       "swatch-17595864660221.jpg",
      "No Background":         "swatch-17601857553100.jpg",
      "Custom":                "swatch-17595905187452.jpg"
    };
    function fixGpoSwatchImages() {
      document.querySelectorAll('.gpo-element.select-background .gpo-ov-item').forEach(function (item) {
        var input = item.querySelector('input');
        if (!input) { return; }
        var f = gpoSwatchFiles[input.value];
        if (!f) { return; }
        item.querySelectorAll('img').forEach(function (img) {
          if (!img.getAttribute('src')) {
            img.src = '/cdn/shop/files/' + f + '?width=330';
          }
        });
      });
    }
    fixGpoSwatchImages();
    var gpoSwatchFixTries = 0;
    var gpoSwatchFixTimer = setInterval(function () {
      fixGpoSwatchImages();
      if (++gpoSwatchFixTries >= 8) { clearInterval(gpoSwatchFixTimer); }
    }, 1000);

    /* Background selection guard. The imported option set lost its default
       value, so nothing is pre-selected and a bare add-to-cart would reach
       the order with no background property. Restore the default, and gate
       the submit with a clear message if somehow nothing is chosen. */
    function ensureBackgroundSelected() {
      if (document.querySelector('input[name="Select Background"]:checked')) { return true; }
      var inputs = Array.prototype.slice.call(document.querySelectorAll('input[name="Select Background"]'));
      var def = inputs.filter(function (i) { return i.value === 'Nightwatch Alley'; })[0] || inputs[0];
      if (def) {
        var lbl = document.querySelector('label[for="' + def.id + '"]');
        (lbl || def).click();
        return true;
      }
      return false;
    }
    ensureBackgroundSelected();
    setTimeout(ensureBackgroundSelected, 1500);

    var atcGuardBtn = document.querySelector('#product-form__buttons button.product-form__submit');
    var atcGuardWrap = document.querySelector('#product-form__buttons');
    if (atcGuardBtn && atcGuardWrap && !atcGuardWrap.dataset.bgGuard) {
      atcGuardWrap.dataset.bgGuard = '1';
      var flashOff = [];
      function clearGateErrors() {
        var msg = document.getElementById('bg-required-msg');
        if (msg) { msg.style.display = 'none'; }
        flashOff.forEach(function (el) { if (el) el.classList.remove('bg-required-flash'); });
        flashOff = [];
      }
      function atcBlock(ev, text, focusEl) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        // Flash the offending section AND every unselected add-on card.
        var targets = focusEl ? [focusEl] : [];
        document.querySelectorAll('.gpo-element.merch-addon').forEach(function (card) { targets.push(card); });
        targets.forEach(function (el) {
          if (!el) { return; }
          el.classList.add('bg-required-flash');
          flashOff.push(el);
          setTimeout(function () {
            el.classList.remove('bg-required-flash');
            var i = flashOff.indexOf(el);
            if (i !== -1) { flashOff.splice(i, 1); }
          }, 3400);
        });
        if (focusEl) {
          focusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        // Error box rendered next to the flashed section, where the scroll lands.
        var msg = document.getElementById('bg-required-msg');
        if (!msg) {
          msg = document.createElement('div');
          msg.id = 'bg-required-msg';
          msg.setAttribute('role', 'alert');
          msg.style.cssText = 'display:none;color:#fff;font-weight:800;font-size:1.05rem;line-height:1.35;margin:14px 0;padding:14px 16px;border:3px solid #111;border-radius:10px;background:#c62828;box-shadow:4px 4px 0 rgba(17,17,17,.85);';
        }
        msg.innerHTML = '&#9888;&#65039; ' + text;
        if (focusEl && focusEl.parentNode) {
          if (msg.parentNode !== focusEl.parentNode) {
            focusEl.parentNode.insertBefore(msg, focusEl.nextSibling);
          }
        } else if (!msg.parentNode) {
          atcGuardWrap.insertBefore(msg, atcGuardBtn);
        }
        msg.style.display = 'block';
      }
      function validateGate(ev) {
        // Only the main Add to Cart button — Buy it now / Shop Pay passes through.
        var t = ev.target && ev.target.closest ? ev.target.closest('button.product-form__submit') : null;
        var disabledClick = !t && atcGuardBtn.disabled && ev.target && ev.target.closest && ev.target.closest('#product-form__buttons');
        if (!t && !disabledClick) { return; }
        // 1) A background must be chosen.
        if (!document.querySelector('input[name="Select Background"]:checked') && !ensureBackgroundSelected()) {
          atcBlock(ev, 'Please choose a background in STEP 1 before adding to cart.',
            document.querySelector('.gpo-element.select-background'));
          return;
        }
        // 2) Loosened Gate: either physical add-on OR digital download only selected.
        var addonPicked = !!document.querySelector('.gpo-element.merch-addon:not(.digital-only-card) input:checked');
        var digitalPicked = !!document.querySelector('#digital_only_radio:checked');
        if (!addonPicked && !digitalPicked) {
          atcBlock(ev, 'Please choose an option below: select a physical print or Digital Download Only to continue.',
            document.querySelector('.merch-addons-heading'));
          return;
        }
        clearGateErrors();
      }
      atcGuardWrap.addEventListener('click', validateGate, true);
      // Live-clear: the moment a required selection is made, hide the error.
      document.addEventListener('change', function (ev) {
        var t = ev.target;
        if (!t || !t.matches) { return; }
        if (t.matches('.gpo-element.merch-addon input') || t.matches('input[name="Select Background"]')) {
          clearGateErrors();
        }
      }, true);
      var flashCss = document.createElement('style');
      flashCss.textContent = '.bg-required-flash{outline:4px solid #c62828 !important;outline-offset:4px;border-radius:8px;animation:bgReqPulse 1.1s ease-in-out 3;}@keyframes bgReqPulse{0%,100%{outline-color:#c62828;}50%{outline-color:#ff9800;}}#bg-required-msg{animation:bgReqShake .45s ease;}@keyframes bgReqShake{0%,100%{transform:translateX(0);}20%,60%{transform:translateX(-6px);}40%,80%{transform:translateX(6px);}}';
      document.head.appendChild(flashCss);
    }

    /* Merch add-on cards: product thumbnails + comic-book styling for the
       Globo add-on elements (classes addon-*). Purely cosmetic; charging
       is untouched. Idempotent via the merch-addon marker class. */
    (function enhanceMerchAddons() {
      var addonArt = {
        'addon-mug':      'https://cdn.shopify.com/s/files/1/0608/4522/8208/files/white-glossy-mug-white-11-oz-front-view-68e6546602712.jpg',
        'addon-blanket':  'https://cdn.shopify.com/s/files/1/0608/4522/8208/files/throw-blanket-50x60-front-68e64ada0ddab.jpg',
        'addon-canvas':   'https://cdn.shopify.com/s/files/1/0608/4522/8208/files/canvas-_in_-12x16-person-68e648065aca4.jpg',
        'addon-framed':   'https://cdn.shopify.com/s/files/1/0608/4522/8208/files/enhanced-matte-paper-framed-poster-_in_-black-12x16-person-68e6497552208.jpg',
        'addon-unframed': 'https://cdn.shopify.com/s/files/1/0608/4522/8208/files/enhanced-matte-paper-poster-_in_-12x16-person-68e64d217a686.jpg'
      };
      // Display order = actual sales popularity (canvas 29, framed 17,
      // unframed 15, mug 15, blanket 3 -- last 250 orders, Aug 2026).
      var addonOrder = ['addon-canvas', 'addon-framed', 'addon-unframed', 'addon-mug', 'addon-blanket'];
      var ordered = [];
      addonOrder.forEach(function (cls) {
        var el = document.querySelector('.gpo-element.' + cls);
        if (!el) { return; }
        if (!el.classList.contains('merch-addon')) {
          el.classList.add('merch-addon');
          var img = document.createElement('img');
          img.className = 'addon-thumb';
          img.loading = 'lazy';
          img.alt = '';
          img.src = addonArt[cls] + '?width=176';
          el.insertBefore(img, el.firstChild);
        }
        ordered.push(el);
      });
      var first = ordered[0] || null;
      if (first) {
        var parent = first.parentNode;
        var h = document.querySelector('.merch-addons-heading');
        if (!h) {
          h = document.createElement('div');
          h.className = 'merch-addons-heading';
          h.innerHTML = 'COMPLETE YOUR COLLECTION!' +
            '<span>Choose a physical print below or select Digital Download Only</span>';
        }
        parent.appendChild(h);

        // Add Digital Download Only option card
        var digitalCard = document.querySelector('.gpo-element.digital-only-card');
        if (!digitalCard) {
          digitalCard = document.createElement('div');
          digitalCard.className = 'gpo-element merch-addon digital-only-card';
          digitalCard.style.cursor = 'pointer';
          digitalCard.innerHTML = '<img class="addon-thumb" src="https://cdn.shopify.com/s/files/1/0608/4522/8208/files/Turned_Comics.jpg?width=176" alt="Digital Download" style="border:2px solid #111;border-radius:10px;object-fit:cover;">' +
            '<div class="gpo-label" style="grid-column:2;margin:0 0 4px !important;font-weight:800;cursor:pointer;">' +
            '<label style="display:flex;align-items:center;gap:10px;cursor:pointer;font-size:1.05rem;font-weight:800;color:#111;margin:0;">' +
            '<input type="radio" name="merch_selection_type" id="digital_only_radio" value="digital_only" style="width:20px;height:20px;accent-color:#111;cursor:pointer;" checked>' +
            '<span>Digital Download Only <span style="display:inline-block;padding:2px 8px;margin-left:6px;border:2px solid #111;border-radius:6px;background:#e8f5e9;font-size:0.8rem;color:#2e7d32;font-weight:800;">FREE (Included)</span></span>' +
            '</label>' +
            '</div>' +
            '<div style="grid-column:2;font-size:0.85rem;color:#555;margin-top:2px;">High-resolution printable digital file delivered to your email. Unlimited revisions included.</div>';
          
          digitalCard.addEventListener('click', function(e) {
            var radio = document.getElementById('digital_only_radio');
            if (radio) { radio.checked = true; }
            document.querySelectorAll('.gpo-element.merch-addon:not(.digital-only-card) input').forEach(function(inp) {
              if (inp.checked) {
                inp.checked = false;
                $(inp).trigger('change');
              }
            });
            clearGateErrors();
          });
        }
        parent.appendChild(digitalCard);
        ordered.forEach(function (el) { parent.appendChild(el); });

        // When physical merch is checked, uncheck digital only
        document.querySelectorAll('.gpo-element.merch-addon:not(.digital-only-card) input').forEach(function(inp) {
          inp.addEventListener('change', function() {
            if (this.checked) {
              var radio = document.getElementById('digital_only_radio');
              if (radio) { radio.checked = false; }
              clearGateErrors();
            }
          });
        });
      }
      if (first && !document.getElementById('merch-addon-style')) {
        var css = document.createElement('style');
        css.id = 'merch-addon-style';
        css.textContent = [
          '.merch-addons-heading{display:block;margin:26px 0 14px;font-family:inherit;}',
          '.merch-addons-heading{font-size:1.35rem;font-weight:800;letter-spacing:.02em;color:#111;',
          '  background:#ffd84d;border:3px solid #111;border-radius:10px;box-shadow:5px 5px 0 rgba(17,17,17,.9);',
          '  padding:10px 16px;transform:rotate(-1deg);}',
          '.merch-addons-heading span{display:block;font-size:.85rem;font-weight:600;letter-spacing:0;margin-top:2px;color:#333;}',
          '.gpo-element.merch-addon{display:grid !important;grid-template-columns:92px 1fr;gap:4px 16px;',
          '  align-items:center;background:#fff;border:3px solid #111;border-radius:12px;',
          '  box-shadow:5px 5px 0 rgba(17,17,17,.9);padding:14px !important;margin:0 0 16px !important;',
          '  transition:transform .15s ease;}',
          '.gpo-element.merch-addon:hover{transform:translate(-2px,-2px);box-shadow:7px 7px 0 rgba(17,17,17,.9);}',
          '.merch-addon .addon-thumb{grid-row:1/4;width:92px;height:92px;object-fit:cover;',
          '  border:2px solid #111;border-radius:10px;background:#f6f6f6;}',
          '.merch-addon .gpo-label{grid-column:2;margin:0 0 4px !important;font-weight:800;}',
          '.merch-addon .gpo-ov-wrapper,.merch-addon .gpo-selected-values{grid-column:2;}',
          '.merch-addon .messages{grid-column:1/3;}',
          '@media (max-width:600px){',
          '  .gpo-element.merch-addon{grid-template-columns:68px 1fr;gap:4px 10px;}',
          '  .merch-addon .addon-thumb{width:68px;height:68px;}',
          '}'
        ].join('\n');
        document.head.appendChild(css);
      }
    })();

    /* Update Step # for each Section */
    // Step 1
    // Get the element to move
    const selectBackgroundToMove = document.querySelector('.gpo-element.select-background');
    // Move the element to the top of the options list, above Step 2
    const productFormOptions = document.querySelector('#product-form__options');
    if(productFormOptions && selectBackgroundToMove){
      productFormOptions.prepend(selectBackgroundToMove);
    }
    var step = 1;
    var label_text = $('.gpo-element.select-background').find('.label-content').text();
    label_text = "STEP "+step+": "+label_text;
    $('.gpo-element.select-background').find('.label-content').text(label_text);
  
    // Step 2
    step +=1;
    var select_number_text = $('.product-form__input.select-number-of-people-and-pets').find('.form__label').text();
    select_number_text = "STEP "+step+": "+select_number_text;
    $('.product-form__input.select-number-of-people-and-pets').find('.form__label').text(select_number_text);
    $('.product-form__input.select-number-of-people-and-pets-custom-dropdown').find('.form__label').text(select_number_text);
    // Step 3
    step +=1;
    var select_style_text = $('.product-form__input.select-picture-style').find('.form__label').text();
    select_style_text = "STEP "+step+": "+select_style_text;
    $('.product-form__input.select-picture-style').find('.form__label').text(select_style_text);
    // Step 4 -- photo upload.
    // Move the Upload-Lift app block (if present) next to the UploadKit slot,
    // so it sits in the flow instead of wherever the theme editor dropped it.
    step +=1;
    const uploadLiftWrapper = document.querySelector('.shopify-app-block .cl-upload--wrapper');
    if (uploadLiftWrapper) {
      const ulBlock = uploadLiftWrapper.closest('.shopify-app-block');
      const uploadAnchor = document.querySelector('.uploadkit');
      if (ulBlock && uploadAnchor) {
        uploadAnchor.parentNode.insertBefore(ulBlock, uploadAnchor.nextSibling);
      }
    }
    var upload_text = $('.uploadkit .uploadkit-label').text();
    if (upload_text) {
      // UploadKit still installed: it keeps the step number.
      upload_text = "STEP "+step+": "+upload_text;
      $('.uploadkit .uploadkit-label').text(upload_text);
    } else if (uploadLiftWrapper) {
      // UploadKit gone: Upload-Lift takes over the step number.
      var ulLabel = uploadLiftWrapper.querySelector('label');
      if (ulLabel && ulLabel.textContent && ulLabel.textContent.indexOf('STEP') !== 0) {
        ulLabel.textContent = "STEP "+step+": "+ulLabel.textContent;
      }
    }

    // Step 5
    // Get the element to move - price
    const drawingNotesToMove = document.querySelector('.gpo-element.drawing-notes'); 
    // Move the element
    const drawingNotes = document.querySelector('.drawing-notes-wrapper');
    if(drawingNotes){
      drawingNotes.append(drawingNotesToMove); 
      step +=1;
      var label_text = $('.gpo-element.drawing-notes').find('.label-content').text();
      label_text = "STEP "+step+": "+label_text;
      $('.gpo-element.drawing-notes').find('.label-content').text(label_text);
    }

    //Step 6
    step +=1;
    var addons_text = $('#spiceaddonsappid .spice-spa-addon-heading').text();
    //addons_text = "STEP "+step+" (OPTIONAL): "+addons_text;
    addons_text = "STEP "+step+": "+addons_text;
    $('#spiceaddonsappid .spice-spa-addon-heading').text(addons_text);
    
  }, 500);
  
  /* Sticky Preview
  var windowWidth = $(window).width();
  if (windowWidth <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        //$('.product__media-wrapper').addClass("sticky");
        //$('.product__info-wrapper').addClass("sticky");
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

    });
  }
  */

});

/*
$(window).on('resize', function() {
  var windowWidthResize = $(window).width();
  if (windowWidthResize <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }
      
     });
  }
});  
*/

$('.hero__reviews').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots:true,
  autoplay:true,
  autoplaySpeed:3500,
  fade: false
});



$window = $(window);
$slick_slider = $('.js-text-slider');
settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
  prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',

};
$slick_slider.slick(settings);

$( window ).on( "load", function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
});

function stickyAddToCart(){
   console.log('Sticky clicked!');
   $('html, body').animate({
      scrollTop: $('#product-form__buttons').offset().top - 100
    }, 1000);
    $('#product-form__buttons .product-form__submit').css('animation','pulse-attention 2s infinite');
}

$window.on('resize', function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
  if ( ! $slick_slider.hasClass('slick-initialized'))
    return $slick_slider.slick(settings);
});  
                            
$(function() {
    var stickyBtn = $(".sticky-btn-bottom");
    var s = $("#MainContent");
    var pos = s.position();

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll > pos.top) {
            stickyBtn.addClass("active");
        } else {
            stickyBtn.removeClass("active");
        }
    });
});


$(window).scroll(function () {
  
  var priceSection = $('.price-section');
  if (priceSection.length) {
   const checkScrollToDiv = $('.price-section').offset().top + $('.price-section').outerHeight();
    if ($(window).scrollTop() >= checkScrollToDiv) {
      $('.price-section .price').addClass('active-sticky');
    }else if($(window).scrollTop() < $('.price-section .price').offset().top + $('.price-section .price').outerHeight()){
      $('.price-section .price').removeClass('active-sticky');
    }
  }
  
}); 


jQuery.fn.shake = function (interval, distance, times) {
  (interval = typeof interval > "u" ? 100 : interval), (distance = typeof distance > "u" ? 10 : distance), (times = typeof times > "u" ? 3 : times);
  var jTarget = $(this);
  jTarget.css("position", "relative");
  for (var iter = 0; iter < times + 1; iter++) jTarget.animate({ left: iter % 2 == 0 ? distance : distance * -1 }, interval);
  return jTarget.animate({ left: 0 }, interval);
};
